import script from "./CollapsibleRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollapsibleRow.vue?vue&type=script&setup=true&lang=ts"

import "./CollapsibleRow.vue?vue&type=style&index=0&id=246ba7ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-246ba7ea"]])

export default __exports__